import classnames from 'clsx';

import style from './settings-page-content.module.css';

import type React from 'react';

export type SettingsPageContentVariant = 'content' | 'content-wrapper' | 'tabbed-content';

type SettingsPageContentProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  isLimitedWidth?: boolean;
  variant?: SettingsPageContentVariant;
};

export const SettingsPageContent = ({
  children,
  className,
  isLimitedWidth = false,
  variant = 'content',
  ...rest
}: SettingsPageContentProps) => {
  return (
    <div
      className={classnames(
        style[variant],
        {
          [style['limited-width-page']]: isLimitedWidth,
        },
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
